<template>
    <div>
        <transition-group
            :duration="100"
            class="columns is-multiline px-2"
            name="flip-list"
            tag="div"
            appear
        >
            <div
                v-for="image in photos"
                :key="image.id"
                class="column is-4 flip-list-item px-1 py-1"
            >
                <div
                    :class="{
                        selected: selectedImage.value.id == image.id,
                    }"
                    class="is-relative"
                    @click="$emit('input', { type: 'unsplash', value: image })"
                >
                    <figure
                        :class="{
                            card: selectedImage.value.id == image.id,
                        }"
                        class="image is-4by3"
                    >
                        <img :src="image.urls.thumb" />
                        <div
                            class="is-overlay is-invisible image-attributtion has-background-grey-lighter is-size-7"
                        >
                            <a
                                :href="`https://unsplash.com/@${image.user.username}?utm_source=eduloc360&utm_medium=referral`"
                                >{{ image.user.name }}</a
                            >
                            on
                            <a
                                href="https://unsplash.com/?utm_source=eduloc360&utm_medium=referral"
                                >Unsplash</a
                            >
                        </div>
                    </figure>
                    <div
                        v-if="selectedImage.value.id == image.id"
                        class="is-overlay"
                    >
                        <div class="lb-selected-background is-overlay" />
                        <p
                            class="has-text-centered has-text-grass-green is-overlay lb-selected-check"
                        >
                            <span class="icon is-large">
                                <i
                                    class="mdi mdi-48px mdi-checkbox-marked-circle"
                                ></i>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
            <!--<app-base-pagination
                v-if="totalPages > 1"
                :current-page="currentPage"
                :page-count="totalPages"
                @pagechanged="currentPage = $event"
            />-->
        </transition-group>
    </div>
</template>

<script>
import { search, listPhotos, triggerDownload } from '@/services/unsplash';
import AppBasePagination from '@/components/AppBasePagination';
import _ from 'underscore';
export default {
    name: 'UnsplashBackground',
    components: {
        AppBasePagination,
    },
    model: { prop: 'selectedImage' },
    props: {
        searchConcept: {
            type: String,
            default: undefined,
        },
        selectedImage: {
            type: Object,
            default: () => {
                return { value: {} };
            },
        },
    },
    data() {
        return {
            photos: [],
            currentPage: 1,
            totalPages: 1,
        };
    },
    watch: {
        searchConcept: {
            handler: 'searchDefaultBackgrounds',
        },
        currentPage: {
            handler: 'searchPaginated',
            immediate: false,
        },
    },

    mounted() {
        // console.log('mounted',this.selectedImage);
        if(!this.selectedImage.value && this.selectedImage.image){
                    //let imageData = _clone(this.selectedImage.image);
                    //delete this.selectedImage.image;
                    this.selectedImage.value = this.selectedImage.image;
                }
        this.searchDefaultBackgrounds();
    },
    methods: {
        resetSearch() {
            this.currentPage = 1;
            this.totalPages = 1;
            this.photos = [];
        },
        async searchDefaultBackgrounds() {
            this.resetSearch();
            if (!this.searchConcept) {
                let response = await listPhotos(1, 11, 'latest');
                console
                this.photos = { ...response }; //response.results for search
            } else {
                this.searchPaginated();
            }
        },
        async searchPaginated() {
            let response = await search(
                this.searchConcept,
                this.currentPage,
                12
            );
            this.totalPages = response.total_pages;
            this.photos = { ...response.results };
        },
        range(start, end) {
            return _.range(start, end);
        },
        triggerDownload,
    },
};
</script>

<style scoped lang="scss">
.selected {
    border: 1px solid black;
    border-radius: 2px;
}
img {
    object-fit: cover;
    border-radius: 2px;
}
.image-attributtion {
    opacity: 0.8;
}
.image:hover {
    .image-attributtion {
        visibility: visible !important;
    }
}
.flip-list-move {
    //transition: transform 1s;
}

.flip-list-item {
    transition: all 0.5s;
}
.flip-list-enter,
.flip-list-leave-to {
    opacity: 0;
}
.flip-list-leave-active {
    //position: absolute;
}
</style>
